import React, { useState } from "react"
import * as styles from "./MoreText.module.css"
import CaretDownDelicate from "../../../../assets/icons/caret-down-delicate.inline.svg"
import useDeviceType from "../../../../hooks/useDeviceType"

type MoreTextProps = {
  children: React.ReactNode
  characters?: number
}

const MoreText = ({ children, characters = 200 }: MoreTextProps) => {
  const deviceType = useDeviceType()
  const [openText, setOpenText] = useState(false)

  const shortText = (children: React.ReactNode) => {
    if (React.isValidElement(children)) {
      if (typeof children.props.children === "string")
        return children.props.children
      else
        return children.props.children
          .map((child: any) => {
            if (child.type === "br") return null
            if (typeof child === "string") return child
            return child.props.children
          })
          .join(" ")
    } else return children
  }

  if (deviceType === "mobile" && !openText) {
    return (
      <p className={styles.text}>
        {shortText(children).slice(0, characters)}
        <span className={styles.more} onClick={() => setOpenText(true)}>
          ...More <CaretDownDelicate />
        </span>
      </p>
    )
  }

  return <>{children}</>
}

export default MoreText
